import { Component, inject } from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TeamMemberService} from '../../../services/team-member.service';
import {TeamMember, TeamRole} from '../../../models/team-member';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-team-member-modal',
    templateUrl: './team-member-modal.component.html',
    standalone: false
})
export class TeamMemberModalComponent {
    private teamMemberService = inject<TeamMemberService>('TeamMemberService' as any);
    modalRef = inject(VwuiModalRef);
    private toast = inject(ToastrService);
    private modalConfig = inject<VwuiModalConfig<{
    refId: number;
    teamMember?: TeamMember;
}>>(VwuiModalConfig);


    form = new UntypedFormGroup({
        id: new UntypedFormControl(null),
        name: new UntypedFormControl(null, [Validators.required, Validators.maxLength(255)]),
        role: new UntypedFormControl(null, [Validators.required])
    });

    saving = false;
    refId: number | undefined = 0;
    teamMember: TeamMember | undefined = undefined;
    action = 'toevoegen';
    readonly roles = Object.values(TeamRole);

    constructor() {
        const modalConfig = this.modalConfig;

        this.refId = modalConfig.data?.refId;
        this.teamMember = modalConfig.data?.teamMember;

        if (this.teamMember) {
            this.action = 'bijwerken';
            this.form.patchValue(this.teamMember);
            this.form.controls.role.patchValue(TeamRole[this.teamMember.role]);
        }
    }

    async saveTeamMember(): Promise<void> {
        if (this.form.invalid || this.saving) {
            return;
        }

        if (!this.refId) {
            return;
        }

        const existingMember = !!this.teamMember;
        try {
            this.saving = true;
            if (existingMember) {
                await this.teamMemberService.update(this.refId, this.form.value).toPromise();
            } else {
                await this.teamMemberService.create(this.refId, this.form.value).toPromise();
            }
            this.modalRef.close();
        } catch (e: any) {
            if (e.error.globalErrors.includes('name_role_unique')) {
                this.toast.error(`${this.form.controls.name.value} heeft de rol ${this.form.controls.role.value} al.`);
            } else {
                console.error(`Error while  ${existingMember ? 'updating' : 'adding'} a team member`, e);
                this.toast.error(`Er is iets misgegaan bij het  ${this.action} van het projectteamlid`);
            }
        } finally {
            this.saving = false;
        }

    }

}
